module.exports = __webpack_public_path__ + "static/media/whatsapp.e66ef9a4.svg";